"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDevelopmentState = void 0;
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
var DevelopmentDetails_init_1 = require("./DevelopmentDetails.init");
var DevelopmentTranslate_init_1 = require("./DevelopmentTranslate.init");
var GetInTouch_init_1 = require("./GetInTouch.init");
exports.defaultDevelopmentState = {
    background: './res/img/masked.jpg',
    isLoading: EnquireState_init_1.defaultEnquireState.isLoading,
    t: DevelopmentTranslate_init_1.defaultDevelopmentTranslate,
    developmentDetails: DevelopmentDetails_init_1.defaultDevelopmentDetails,
    sticky: false,
    getInTouch: GetInTouch_init_1.defaultGetInTouch,
};
